export function download(url: string, filename?: string) {
  const link = document.createElement("a");
  link.setAttribute("download", filename || url.split("/").pop() || "download");
  link.href = url;
  link.target = "_blank";

  link.click();
}

export function downloadText(
  data: string,
  filename: string,
  mimeType = "text/csv;charset=utf-8;",
) {
  const blob = new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
